import { useSnackbar } from 'notistack';

import { useSnackbarFromGenerated } from '../../../components/snackbars/useSnackbarFromGenerated.ts';
import { trpc } from '../../../trpc';
import {
  generateVeranstaltungListingErrorSnackbar,
  generateVeranstaltungListingSuccessSnackbar,
} from '../../snackbars';
import {
  generateUpdateStatusOfVeranstaltungErrorSnackbar,
  generateUpdateStatusOfVeranstaltungSuccessSnackbar,
  statusChangeErrorMessage,
} from '../../snackbars/updateStatusOfVeranstaltungSnackbars';
import { content } from '../content';

export function useVeranstaltungenStatusMutation({ openLinksInNewTab = false }: { openLinksInNewTab?: boolean } = {}) {
  const { enqueueSnackbar } = useSnackbar();
  const { enqueueSnackbarFromGenerated } = useSnackbarFromGenerated();

  return trpc.planung.updateStatusOfVeranstaltungen.useMutation({
    onError: () => {
      enqueueSnackbar(statusChangeErrorMessage, { variant: 'error', persist: true });
    },
    onSuccess: (mutateResult, input) => {
      if (mutateResult.length === 0) {
        enqueueSnackbar(content.keineVeranstaltungenAenderung, { variant: 'info' });
      } else if (mutateResult.length === 1) {
        const veranstaltung = mutateResult[0];
        if (veranstaltung.errorMessages.length > 0) {
          enqueueSnackbarFromGenerated(generateUpdateStatusOfVeranstaltungErrorSnackbar(veranstaltung));
        } else {
          enqueueSnackbarFromGenerated(generateUpdateStatusOfVeranstaltungSuccessSnackbar(veranstaltung));
        }
      } else {
        const successVeranstaltungen = mutateResult.filter((result) => result.successMessages.length > 0);
        if (successVeranstaltungen.length > 0) {
          enqueueSnackbarFromGenerated(generateVeranstaltungListingSuccessSnackbar(successVeranstaltungen));
        }

        const failedVeranstaltungen = mutateResult.filter((result) => result.errorMessages.length > 0);
        if (failedVeranstaltungen.length > 0) {
          enqueueSnackbarFromGenerated(
            generateVeranstaltungListingErrorSnackbar({
              veranstaltungen: failedVeranstaltungen,
              newStatus: input.newStatus,
              openLinksInNewTab,
            }),
          );
        }
      }
    },
  });
}
